import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedLayoutComponent } from "./med-layout.component";
import { MedHeaderModule } from "../../navigation/med-header/med-header.module";
import { MedDirectiveSharedModule } from "../../../directives/med-directive-shared.module";
import { MedWarshipBannerModule } from "../../navigation/med-warship-banner/med-warship-banner.module";

@NgModule({
  declarations: [
    MedLayoutComponent,
  ],
  imports: [
    CommonModule,
    MedHeaderModule,
    MedWarshipBannerModule,
    MedDirectiveSharedModule,
  ],
  exports: [
    MedLayoutComponent,
  ],
})
export class MedLayoutModule { }
